<template>
  <div class="imageBox">
    <div
      class="download"
      :class="!store.state.isPc ? 'downloadImg' : 'downloadImgPc'"
      alt=""
    >
      <div class="button" @click="openDownload">
        {{ store.state.language == "cn" ? "划船机专用软件：船道APP下载" : "Download the Rowing Machine Dedicated Software:PowerFun APP" }}
      </div>
    </div>
    <div
      class="download"
      :class="!store.state.isPc ? 'downloadSettingM' : 'downloadSettingPc'"
      style="margin-top: 20px;"
      alt=""
    >
      <div class="button" @click="openDownload1">
        {{ store.state.language == "cn" ? "PowerFun设备管理软件：PowerFun设置" : "PowerFun Device Management Software:PowerFun Setting" }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { useRouter } from "vue-router";
const store = useStore();
const router = useRouter();

const openDownload = ()=>{
  // window.open("https://wx.powerfun.com.cn/download.html")
  router.push("/DownloadView")
}

const openDownload1 = ()=>{
  // window.open("https://wx.powerfun.com.cn/download.html")
  router.push("/DownloadView1")
}
</script>
<!-- getImagePath('软件图片.png') -->
<style lang="scss" scoped>
.imageBox {
  width: 80%;
  // height: calc(100vh - 170px);
  max-width: 75rem;
  margin: 0 auto;
  padding-top: 1.5rem;
  min-width: 42.75rem;
  min-height: calc(100% - 6.875rem);

  .download {
    background: url(../assets//images/软件图片.png);
    height: 23rem;
    width: 100%;
    background-size: 100% 100% !important;
    //background-repeat: no-repeat;
    
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  //   .downloadImg {
  //     width: 694px;
  //   }

    .downloadImgPc {
      background: url(../assets//images/2软件图片.png);
    }

    .downloadSettingPc{
      background: url(../assets//download/SettingsPc.png);
    }
    .downloadSettingM{
      background: url(../assets//download/SettingsM.png);
    }
  .button {
//    width: 8.625rem;
    padding: 0 1rem;
    height: 2.625rem;
    line-height: 2.625rem;
    text-align: center;
    font-family: SourceHanSansCN-Regular;
    font-size: 1.375rem;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 400;
    background-color: #ff000d;
    border-radius: 0.5rem;
    cursor: pointer;
    padding-bottom: 0.05rem;
  }
}
</style>
